import Vue from 'vue'
import store from '../store/'

//全局mixin
Vue.mixin({
    methods: {
      clearStore() {
            store.dispatch('clearGlobal');
            store.dispatch('clearHeadTab');
            store.dispatch('clearInclude');
            store.dispatch('clearRecords')
        }
    }
});



// WEBPACK FOOTER //
// ./src/mixin/index.js